import React from 'react';
import glamorous from 'glamorous';

import Body from '../typography/Body';
import RangeInput from '../ui/RangeInput';

import StickersheetRow from './StickersheetRow';

const styleTitle = {
  marginBottom: 16,
  textTransform: 'capitalize',
};

const Row = glamorous.div({
  display: 'flex',
  flexWrap: 'wrap',
});

export default () => (
  <StickersheetRow title="RangeInputs">
    <div>
      <Body style={styleTitle}>Default</Body>
      <Row>
        <RangeInput
          tipFormatter={(value) => `$${value}`}
        />
      </Row>
    </div>
    <div>
      <Body style={styleTitle}>Tooltip</Body>
      <Row>
        <RangeInput
          hasTooltip
          min={50}
          max={250}
          defaultValue={[55, 200]}
          onChange={(value) => console.log(value)}
          tipFormatter={(value) => `$${value}`}
        />
      </Row>
    </div>
    <div>
      <Body style={styleTitle}>Icons</Body>
      <Row>
        <RangeInput
          min={1}
          max={5}
          defaultValue={[1, 5]}
          onChange={(value) => console.log(value)}
          tipFormatter={(value) => (new Array(value + 1)).join('$')}
        />
      </Row>
    </div>
  </StickersheetRow>
);



// WEBPACK FOOTER //
// ./src/components/demo/RangeInputs.js